import React, { useState, memo, useMemo, useCallback } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import { formatPhoneNumber } from 'Utils/Formatters'

import DeleteIcon from 'Assets/Images/icons/delete'
import CheckedIcon from 'Assets/Images/icons/checked'
import ForbiddenIcon from 'Assets/Images/icons/forbidden'
import ArrowIcon from 'Assets/Images/icons/arrow'
import EyeIcon from 'Assets/Images/icons/eye'
import { dateFormater } from '../../../index'

import style from './style'

function ColumnItem({
  provided,
  snapshot,
  columnName,
  item,
  onDelete,
  url,
  onDocumentsModalOpen,
  onApprovedModalOpen,
}) {
  const history = useHistory()
  const [isToggleDocuments, setIsToggleDocuments] = useState(false)

  const {
    isShowPhone,
    isShowDocuments,
    isShowDelete,
    googleData,
    documents,
    preSignupStep,
    handleDocumentsModals,
  } = useMemo(() => {
    const { status, googleEventMetadata } = item
    const isShowPhone = status !== 'BLOCKED'
    const isShowDelete = status !== 'ACTIVE'
    const isShowDocuments = status !== 'BLOCKED' && status !== 'PENDING'

    var handleDocumentsModals
    if (status === 'ACTIVE') {
      handleDocumentsModals = () => onDocumentsModalOpen(item, true)
    }

    if (status === 'WAITING_FOR_REVIEW') {
      handleDocumentsModals = () => onApprovedModalOpen(item)
    }

    var googleData = {}
    if (googleEventMetadata && status !== 'BLOCKED') {
      const {
        status,
        start: { dateTime, timeZone },
        extendedProperties: {
          private: { type },
        },
      } = googleEventMetadata

      googleData = {
        start: `${dateFormater(
          new Date(dateTime).toLocaleString('en-US', {
            timeZone,
          }),
        )} ${new Date(dateTime).toLocaleTimeString('en-US')}`,
        status,
        type,
      }
    }

    const {
      providedPersonalDocuments: { edges: documents = [] },
    } = item

    var preSignupStep
    if (columnName == 'refused') {
      preSignupStep = ''
    } else if (columnName == 'booked') {
      preSignupStep = 'S6'
    } else if (columnName == 'interested') {
      preSignupStep = 'S4'
    } else if (documents.length) {
      preSignupStep = 'ID1'
    }

    return {
      preSignupStep,
      isShowPhone,
      isShowDocuments,
      googleData,
      documents,
      isShowDelete,
      handleDocumentsModals,
    }
  }, [item])

  const classes = useColumnItemStyle({
    isDragging: snapshot.isDragging,
    draggableStyle: provided.draggableProps.style,
  })

  const handleDelete = useCallback(() => onDelete({ ...item, columnName }), [
    item,
    onDelete,
  ])

  const handleToggleDocuments = useCallback(
    () => setIsToggleDocuments(!isToggleDocuments),
    [isToggleDocuments],
  )

  const redirectToUserDitails = useCallback(
    () => history.push(`${url}/${item.id}`),
    [item.id, url],
  )

  return (
    <div
      onDoubleClick={redirectToUserDitails}
      className={classes.body}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      <div className={classes.header}>
        <Link to={`${url}/${item.id}`} className={classes.name}>
          {item.lastName} {item.firstName}
        </Link>
        <div className={classes.controls}>
          <div className={classes.memberSince}>{item.memberSinceFormated}</div>
          {handleDocumentsModals && (
            <EyeIcon
              onClick={handleDocumentsModals}
              fill="#EE4360"
              className={classes.handleDocumentsModalsCursor}
            />
          )}
          {isShowDocuments && (
            <div
              onClick={handleToggleDocuments}
              className={classes.documentsList}
            >
              {preSignupStep}
              {isToggleDocuments ? (
                <ArrowIcon
                  fill="#7f8fa4"
                  className={
                    classes.documentsListCursor +
                    ' ' +
                    classes.documentsListCursorOpen
                  }
                />
              ) : (
                <ArrowIcon
                  fill="#7f8fa4"
                  className={classes.documentsListCursor}
                />
              )}
            </div>
          )}
          {!isShowDocuments && (
            <div className={classes.documentsList}>{preSignupStep}</div>
          )}
          {isShowDelete && (
            <div onClick={handleDelete} className={classes.deleteUser}>
              <DeleteIcon height="12px" fill="#808792" />
            </div>
          )}
        </div>
      </div>
      <div className={classes.content}>
        {isToggleDocuments &&
          documents.map(({ node: item }, index) => (
            <div key={item.documentTypeName + index} className={classes.item}>
              <Link className={classes.documents} to={item.url}>
                {item.documentTypeName}
              </Link>
              <div className={classes.itemStatus}>
                <CheckedIcon height="7px" fill="#00b200" />
              </div>
            </div>
          ))}
        {isShowPhone && (
          <div className={classes.item}>
            <div className={classes.itemText}>
              {formatPhoneNumber(item.mobilePhone) || item.mobilePhone}
            </div>
          </div>
        )}
        {googleData.start && (
          <div className={classes.item}>
            <div className={classes.itemText}>{googleData.start}</div>
            <div className={classes.itemStatus}>
              {googleData.status === 'confirmed' ? (
                <CheckedIcon height="7px" fill="#00b200" />
              ) : (
                <ForbiddenIcon height="7px" fill="#e80000" />
              )}
            </div>
          </div>
        )}
        {googleData.type && (
          <div className={classes.item}>
            <div className={classes.itemText}>
              {googleData.type === 'OFFLINE' ? 'Offline' : 'Online'}
            </div>
          </div>
        )}
        {item.recruitmentChannel && (
          <div className={classes.item}>
            <div className={classes.itemText}>{item.recruitmentChannel}</div>
          </div>
        )}
      </div>
    </div>
  )
}

const useColumnItemStyle = makeStyles(props => ({
  ...style,
  body: {
    ...style.body,
    boxShadow: props.isDragging ? '1.7px 1.7px 8.6px rgba(0, 0, 0, 0.25)' : '',
    ...props.draggableStyle,
  },
}))

export default memo(ColumnItem)



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasadors/AmbassadorsPipelineView/components/PipelineColumn/ColumnItem/index.js